import { Directive, ElementRef, inject, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({ selector: '[bnWebUiHighlightWords]' })
export class HighlightWordsDirective implements OnChanges {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input()
  public searchedWords?: string[];

  @Input()
  public text?: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.text?.currentValue === changes.text?.previousValue && changes.searchedWords?.currentValue === changes.searchedWords?.previousValue) {
      return;
    }

    if (!this.searchedWords || !this.searchedWords.length) {
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.text);

      return;
    }

    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.getFormattedText());
  }

  getFormattedText(): string | undefined {
    const re = new RegExp(`(${this.searchedWords?.join('|')})`, 'gi');

    return this.text?.replace(re, `<strong>$1</strong>`);
  }
}
